/*
 * 由于视频后来支持外部的iframe插入，所以对
 */
function resetIframeSize() {
  let docWidth = document.querySelector('.content').offsetWidth
  let ifs = Array.from(document.querySelectorAll('iframe'))
  if (ifs.length > 0) {
    ifs.map(item => {
      let wh = item.width / item.height
      item.width = docWidth
      item.height = docWidth / wh
    })
  }
}

export default {
  resetIframeSize
}
export { resetIframeSize }



// WEBPACK FOOTER //
// ./src/pages/promotion/template/components/video.js